module.exports = __webpack_public_path__ + "static/media/36-3.b0290791.mp3";